<template>
	<div class="container">
		<top :currentComponent="currentComponent" @Select="Select" :topList="topList"></top>
		<component :is="currentComponent"></component>
	</div>
</template>
<script>
	import top from "@/views/mechanism/children/top";
	import organization from './components/organizationChild/organizationInfo'
	import company from './components/organizationChild/company'
	import organizationSet from './components/organizationChild/organizationSet'
	export default {
		components: {
			top,
			organization,
			company,
			organizationSet
		},
		data() {
			return {
				topList: [{
						name: "机构信息",
						to: "organization",
					},
					{
						name: "机构认证页面",
						to: "company",
					},
					{
						name: "机构店铺设置",
						to: "organizationSet",
					},
					{
						name: "定制师认证",
						to: "暂无页面",
					},
					{
						name: "系统消息",
						to: "暂无页面",
					}],
					currentComponent:'organization',
				}
			},
			methods:{
				Select(val) {
					this.currentComponent = val
				}
			},
			mounted() {
				console.log(this.$route.query,'看看坎坎坷坷');
				let data = this.$route.query
				if(JSON.stringify(data) !== '{}') {
					 this.currentComponent = data.currentComponent
				}
			},
		}
</script>

<style lang="scss" scoped>
	.container {
		height: 8rem;
		width: 100%;
	}
</style>
